export const createRoleTemplatePageMessages = {
  // Page titles and headers
  title: 'Create Role Template',
  subtitle: 'Create a new role template for story templates',

  // Success messages
  successMessage: 'Role template created successfully!',

  // Error messages
  errorCreating: 'Failed to create role template',
  errorMessage: 'An error occurred while creating the role template',

  // Navigation
  backToRoleTemplates: 'Back to Role Templates',
} as const;
